import React from 'react';

import Data, { _F } from 'data';
import ItemEditor, { EngravingPicker } from 'components/editor/ItemEditor';
import Paperdoll from 'components/Paperdoll';

import Store from 'store';
import EditingContext from 'store/editingContext';
import Dialog from 'ui/dialog';
import BlockClearButton, { builderHasPaperdoll } from './common';

const slotNames = {
  head: 'tip.name.enum_equipslot_head',
  shoulders: 'tip.name.enum_equipslot_shoulder',
  torso: 'tip.name.enum_equipslot_upper_body',
  legs: 'tip.name.enum_equipslot_lower_body',
  hands: 'tip.name.enum_equipslot_hand',
  weapon: 'tip.name.enum_equipslot_weapon',
  necklace: 'tip.name.enum_equipslot_neck',
  earring1: 'tip.name.enum_equipslot_ear1',
  earring2: 'tip.name.enum_equipslot_ear2',
  ring1: 'tip.name.enum_equipslot_finger1',
  ring2: 'tip.name.enum_equipslot_finger2',
  stone: 'tip.name.enum_equipslot_ability_stone',
  bracelet: 'tip.name.enum_equipslot_bracelet',
};

export default function BuilderPaperdoll() {
  const editing = EditingContext.useStateView("builderEditing");

  const builder = Store.useBuilder();
  const dispatch = Store.useDispatch();
  const [slot, onSelect] = React.useState(null);
  const onChangeEngraving = React.useCallback(cbk => dispatch.setBuilder(builder => ({...builder, [slot]: cbk(builder[slot])})), [slot, dispatch]);
  const onChangeItem = React.useCallback(value => dispatch.setBuilder(builder => {
    const prev = builder.items[slot];
    if (typeof value === "function") value = value(prev);
    if (value === prev) return builder;
    return {...builder, items: {...builder.items, [slot]: value}};
  }), [slot, dispatch]);
  const onClose = React.useCallback(() => onSelect(null), []);

  const onClear = React.useCallback(builder => ({...builder, items: {}, engraving1: null, engraving2: null}), []);

  return <>
    <div className="lap-BuilderBlock lap-BuilderPaperdoll">
      <div className="lap-BuilderBlockHeader">
        Items
        {!!(editing && builderHasPaperdoll(builder)) && <BlockClearButton onClear={onClear}/>}
      </div>
      <Paperdoll embed={builder} selected={slot} onSelect={editing ? onSelect : null} noStats/>
    </div>
    {!!slot && (
      <Dialog className="lap-BuilderEditor" onClose={onClose} title={`Editing ${_F(slotNames[slot])}`}>
        <Dialog.Content>
          {(slot === 'engraving1' || slot === 'engraving2') && <EngravingPicker value={builder[slot]} onChange={onChangeEngraving} charClass={builder.class}/>}
          {slot !== 'engraving1' && slot !== 'engraving2' && <ItemEditor charClass={builder.class} slot={Data.itemSlots[slot].type} item={builder.items[slot]} onChange={onChangeItem} filterSource/>}
        </Dialog.Content>
      </Dialog>
    )}
  </>;
}
